<template>
    <el-dialog
        title="免责条款"
        :visible.sync="centerDialogVisible"
        width="30%"
        center>
        <div v-html="orderRemark.content" v-loading="loading">

        </div>
        <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span>
    </el-dialog>
</template>
<script>
import OrderApi from '@/components/Api/order'
export default {
    data() {
        return {
            orderRemark: {},
            centerDialogVisible:false,
            loading:false
        }
    },
    methods:{
        open() {
            this.centerDialogVisible = true
            this.getOrderRemark()

        },
        async getOrderRemark() {
            this.loading = true
            try {
                const res = await new OrderApi('order').getOrderRemarkList()
                if (res.status === 200) {
                    if(res.data.length > 0) {
                        this.orderRemark = res.data[0]
                    }
                    this.loading = false
                } else {
                    this.$message.error(res.statusText);
                    this.loading = false
                }
            } catch (err) {
                this.$message.error('加载失败!');
                this.loading = false
            }
        }
    }
}

</script>
<style scoped lang="scss">

</style>